/**
 * Customer surfaces omit rows explicitly marked hidden.
 * A missing or false `hidden` flag stays visible — the same predicate the HTML customer view uses.
 */
export function customerVisibleRows<T extends { hidden?: boolean }>(rows: readonly T[]): T[] {
  return rows.filter((row) => row.hidden !== true);
}
